import { patchState, WritableStateSource } from '@ngrx/signals';
import { AuthState } from '../auth.state';
import { Router } from '@angular/router';

export const logout = (
  store: WritableStateSource<AuthState>,
  router: Router,
) => {
  return () => {
    patchState(store, {loggedIn: false});
    router.navigate(['/']);
  }
};
